import { ConfigProvider, theme, App as AntdApp } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <ConfigProvider theme={{
      algorithm: theme.darkAlgorithm, token: { colorPrimary: '#E5FF01', colorTextLightSolid: '#000000' }, components: {
        Button: {
          //borderRadius: 100,
        },
        Radio: {
          //borderRadius: 100,
        },
        Checkbox: {
          colorPrimary: '#E5FF01',  // Color de fondo del checkbox cuando está seleccionado
          colorTextLightSolid: '#000000', // Color del check dentro del checkbox cuando está seleccionado
          //colorBorder: '#E5FF01',  // Color del borde cuando no está seleccionado
          //colorBorderHover: '#FF9900',  // Color del borde cuando el checkbox está en hover
          //colorBgContainer: '#ffffff',  // Color de fondo cuando no está seleccionado
          //colorBgContainerDisabled: '#f5f5f5', // Color de fondo cuando está deshabilitado
        },
        Select: {
          //borderRadius: 100,
        },
        Input: {
          //borderRadius: 100,
        },
        Typography: {
          fontSize: 16, // Tamaño general para Text y Paragraph
          lineHeight: 1.5, // Altura de línea para mejorar la legibilidad
        },

      },
    }}>
      <AntdApp>
        <App />
      </AntdApp>

    </ConfigProvider>
  </React.StrictMode>
);
